module.exports = __webpack_public_path__ + "static/media/flight_yellow_24dp.40a72523.svg";